import React, { useEffect, useState } from "react";
import {
  DownloadFileFolderApi,
  GetBookKeepingDocumentApi,
} from "../../../api/request/documents/documents";
import toast from "react-hot-toast";
import { saveAs } from "file-saver";
import View from "../../../assets/View";
import { ReactComponent as Download } from "../../../assets/download.svg";
import SkeletonTable from "../../../components/table/SkeletonTable";
import ModalComponent from "../../../components/modals/ModalComponent";
import { Spin } from "antd";

const ViewBookKeepingModal = ({
  data,
  selectedData,
  isLoading,
  isOpen,
  setIsOpen,
  userId,
}) => {
  const [downloadingDocId, setDownloadingDocId] = useState(null);
  const [documentData, setDocumentData] = useState([]);
  const [isDocumentLoading, setIsDocumentLoading] = useState(false);

  const columns = [
    {
      title: "Section Name",
      dataIndex: "section_name",
      render: (value) => (value ? value : "--"),
    },
    {
      title: "Question",
      dataIndex: "field_label",
      render: (value) => (
        <p className="truncate w-[200px]" title={value}>
          {value}
        </p>
      ),
    },
    {
      title: "Document Name",
      dataIndex: "original_name",
      render: (value) => (
        <p className="truncate w-[200px]" title={value}>
          {value || "--"}
        </p>
      ),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (value) => value,
    },
  ];

  const downloadFileFolderManager = async (item) => {
    try {
      setDownloadingDocId(item?.document_id);

      const params = { doc_id: item?.document_id, user_id: userId };
      const res = await DownloadFileFolderApi(params, {
        responseType: "arraybuffer",
      });

      const blob = new Blob([res.data]);
      const fileName = item?.original_name || "downloaded_file";

      saveAs(blob, fileName);
    } catch (error) {
      const msg = error?.response?.data?.error || "Failed to download file";
      toast.error(msg);
      console.error("Download error:", msg);
    } finally {
      setDownloadingDocId(null);
    }
  };

  const getBookKeepingData = async () => {
    if (!selectedData) return;
    try {
      setIsDocumentLoading(true);
      const { data } = await GetBookKeepingDocumentApi({
        bookkeeping_id: selectedData?.id,
      });

      const docs = buildActionDocs(
        data?.data?.documents,
        downloadingDocId,
        downloadFileFolderManager
      );
      setDocumentData(docs);
    } catch (error) {
      if (error?.response?.data?.message)
        toast?.error(error?.response?.data?.message);
    } finally {
      setIsDocumentLoading(false);
    }
  };

  useEffect(() => {
    if (isOpen) getBookKeepingData();
  }, [selectedData]);

  const buildActionDocs = (docs, downloadingDocId, downloadFileFolderManager) =>
    Array.isArray(docs)
      ? docs.map((item) => ({
          ...item,
          action: (
            <div className="flex items-center gap-3 cursor-pointer">
              <button onClick={() => window?.open(item.path, "_blank")}>
                <View />
              </button>

              {downloadingDocId === item?.document_id ? (
                <Spin />
              ) : (
                <button
                  onClick={(e) => {
                    e?.stopPropagation();
                    downloadFileFolderManager(item);
                  }}
                >
                  <Download className="size-5" />
                </button>
              )}
            </div>
          ),
        }))
      : [];

  useEffect(() => {
    if (Array?.isArray(data)) {
      setDocumentData(
        buildActionDocs(
          data.documents,
          downloadingDocId,
          downloadFileFolderManager
        )
      );
    }
  }, [data]);

  return (
    <div>
      <ModalComponent setIsOpen={setIsOpen} isOpen={isOpen} width={1000}>
        <div className="mb-5 text-center font-semibold text-xl">
          <p>View All Documents</p>
          <p className="capitalize">{`${data[0]?.file_name} (#${data[0]?.file_number})`}</p>
        </div>
        <SkeletonTable
          columns={columns}
          data={Array.isArray(documentData) ? documentData : []}
          isLoading={isLoading || isDocumentLoading}
          onRowClick={(data) => window?.open(data?.path, "_blank")}
        />
      </ModalComponent>
    </div>
  );
};

export default ViewBookKeepingModal;
